import { createSlice } from "@reduxjs/toolkit";
import {
  addBusinessAddressAction,
  addCustomerSupplierAction,
  addStockItemAction,
  addUnitMeasurementListAction,
  addStockGrouopAction,
  checkUniqueLegalCustomerSupplierAction,
  editBusinessAddressAction,
  editCustomerSupplierAction,
  getAllBusinessAddressAction,
  getAllCustomerSupplierAction,
  getAllExpensesLedgersListAction,
  getAllIncomeLedgersListAction,
  getAllTypesLedgerListAction,
  getAllTypesParentStockGroupAction,
  getAllTypesStocksGroupAction,
  getAllTypesWithTaxListAction,
  getAllUnitMeasurementListAction,
  getSingleTypeLedgerListAction,
  updateStockGroupAction,
  updateUnitsMeasermentAction,
  getAllStockItemListAction,
  updateStockItemAction,
  checkUniqueSkuNumberAction,
  getSingleCustomerSupplierAction,
  getDepartmentListAction,
  createDepartmentAction,
  updateDepartmentAction,
  checkUniqueDepartmentNameAction,
  getSingleBusinessAddressAction,
  getSingleStockItemDataAction,
  getMultipleStockItemQuantityAction,
  changeCustomerSupplierStatusAction,
  getMappedPdfTemplateAction,
  createMappedPdfTemplateAction,
  multipleUploadFilesAction,
  stockItemBulkUploadDataAction,
  addTurnOverHSNCheckAction,
  updateTurnOverHSNCheckAction,
  getHsnCheckAction,
  addHsnCheckWarningAction,
  customerSupplierBulkUploadDataAction,
  addBatchManagementAction,
  updateBatchManagementAction,
  getBatchManagementAction,
  getSingleBatchManagementAction,
  changeBatchStatusAction,
  checkUniqueBatchNumberAction,
  addAutoUniqueNumberGenerationAction,
  getAutoUniqueNumberGenerationAction,
  getStockMappedBatchListAction,
  getCustomerSupplierGroupingListAction,
} from "./actions";
import {
  addLedgerAction,
  checkUniqueLedgerAction,
  getAllLedgersListAction,
  initialState,
  updateLedgerAction,
} from ".";
import { ClientSettingsType } from "./clientSettingTypes";
import { clientSettingsReducer } from ".";

export const clientSettingsSlice = createSlice({
  name: "clientSettings",
  initialState,
  reducers: clientSettingsReducer,
  extraReducers: {
    // Business Address Module Actions
    [addBusinessAddressAction.pending.toString()]: (
      state: ClientSettingsType
    ) => ({
      ...state,
      fetching: true,
    }),
    [addBusinessAddressAction.fulfilled.toString()]: (
      state: ClientSettingsType,
      { payload }
    ) => {
      const { success, message, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          error: message,
          statusCode: status_code,
        };
      }

      return {
        ...state,
        fetching: false,
        success,
        statusCode: status_code,
      };
    },
    [addBusinessAddressAction.rejected.toString()]: (
      state: ClientSettingsType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),
    [editBusinessAddressAction.pending.toString()]: (
      state: ClientSettingsType
    ) => ({
      ...state,
      fetching: true,
    }),
    [editBusinessAddressAction.fulfilled.toString()]: (
      state: ClientSettingsType,
      { payload }
    ) => {
      const { success, message, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          error: message,
          statusCode: status_code,
        };
      }

      return {
        ...state,
        fetching: false,
        success,
        statusCode: status_code,
      };
    },
    [editBusinessAddressAction.rejected.toString()]: (
      state: ClientSettingsType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),
    [getAllBusinessAddressAction.pending.toString()]: (
      state: ClientSettingsType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getAllBusinessAddressAction.fulfilled.toString()]: (
      state: ClientSettingsType,
      { payload }
    ) => {
      const { success, message, result, status_code } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          error: message,
          statusCode: status_code,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        businessAddressList: result,
      };
    },
    [getAllBusinessAddressAction.rejected.toString()]: (
      state: ClientSettingsType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),
    // single business addres
    [getSingleBusinessAddressAction.pending.toString()]: (
      state: ClientSettingsType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getSingleBusinessAddressAction.fulfilled.toString()]: (
      state: ClientSettingsType,
      { payload }
    ) => {
      const { success, message, result, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          error: message,
          statusCode: status_code,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        singleBusinessAddressList: result,
      };
    },
    [getSingleBusinessAddressAction.rejected.toString()]: (
      state: ClientSettingsType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),

    // Customer/Supplier Module Actions
    [addCustomerSupplierAction.pending.toString()]: (
      state: ClientSettingsType
    ) => ({
      ...state,
      fetching: true,
    }),
    [addCustomerSupplierAction.fulfilled.toString()]: (
      state: ClientSettingsType,
      { payload }
    ) => {
      const { success, message, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          error: message,
          statusCode: status_code,
        };
      }

      return {
        ...state,
        fetching: false,
        success,
        statusCode: status_code,
      };
    },
    [addCustomerSupplierAction.rejected.toString()]: (
      state: ClientSettingsType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),

    [changeCustomerSupplierStatusAction.pending.toString()]: (
      state: ClientSettingsType
    ) => ({
      ...state,
      fetching: true,
    }),
    [changeCustomerSupplierStatusAction.fulfilled.toString()]: (
      state: ClientSettingsType,
      { payload }
    ) => {
      const { success, status_code, message } = payload;

      if (success === 0) {
        return {
          ...state,
          error: message,
          success,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },

    [changeCustomerSupplierStatusAction.rejected.toString()]: (
      state: ClientSettingsType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),

    [editCustomerSupplierAction.pending.toString()]: (
      state: ClientSettingsType
    ) => ({
      ...state,
      fetching: true,
    }),
    [editCustomerSupplierAction.fulfilled.toString()]: (
      state: ClientSettingsType,
      { payload }
    ) => {
      const { success, message, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          error: message,
          statusCode: status_code,
        };
      }

      return {
        ...state,
        fetching: false,
        success,
        statusCode: status_code,
        customerSupplierMessage: message,
      };
    },
    [editCustomerSupplierAction.rejected.toString()]: (
      state: ClientSettingsType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),
    [getAllCustomerSupplierAction.pending.toString()]: (
      state: ClientSettingsType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getAllCustomerSupplierAction.fulfilled.toString()]: (
      state: ClientSettingsType,
      { payload }
    ) => {
      const { success, message, result, status_code, total_count } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          error: message,
          statusCode: status_code,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        customerSupplierList: result,
        customerSupplierListTotal: total_count,
      };
    },
    [getAllCustomerSupplierAction.rejected.toString()]: (
      state: ClientSettingsType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),
    [getSingleCustomerSupplierAction.pending.toString()]: (
      state: ClientSettingsType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getSingleCustomerSupplierAction.fulfilled.toString()]: (
      state: ClientSettingsType,
      { payload }
    ) => {
      const { success, message, result, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          error: message,
          statusCode: status_code,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        singleCustomerSupplier: result,
      };
    },
    [getSingleCustomerSupplierAction.rejected.toString()]: (
      state: ClientSettingsType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),
    [addLedgerAction.pending.toString()]: (state: ClientSettingsType) => ({
      ...state,
      fetching: true,
    }),
    [addLedgerAction.fulfilled.toString()]: (
      state: ClientSettingsType,
      { payload }
    ) => {
      const { success, message, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          error: message,
          statusCode: status_code,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },
    [addLedgerAction.rejected.toString()]: (
      state: ClientSettingsType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),
    [checkUniqueLedgerAction.pending.toString()]: (
      state: ClientSettingsType
    ) => ({
      ...state,
      uniqueLedgerFetching: true,
      ledgerMessage: null,
    }),
    [checkUniqueLedgerAction.fulfilled.toString()]: (
      state: ClientSettingsType,
      { payload }
    ) => {
      const { success, message, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          success,
          fetching: false,
          uniqueLedgerFetching: false,
          ledgerMessage: null,
          error: message,
          statusCode: status_code,
        };
      }

      return {
        ...state,
        fetching: false,
        uniqueLedgerFetching: false,
        ledgerMessage: message,
      };
    },
    [checkUniqueLedgerAction.rejected.toString()]: (
      state: ClientSettingsType,
      { error }
    ) => ({
      ...state,
      uniqueLedgerFetching: false,
      fetching: false,
      success: 0,
      error: error?.message,
    }),
    [getAllLedgersListAction.pending.toString()]: (
      state: ClientSettingsType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getAllLedgersListAction.fulfilled.toString()]: (
      state: ClientSettingsType,
      { payload }
    ) => {
      const { status_code, result, message, success, total_count } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          error: message,
          statusCode: status_code,
        };
      }

      let finalData: any = [];

      // Manipulating Data
      result &&
        result?.length > 0 &&
        result?.map((tempData: any) => {
          if (tempData?.to_show) {
            finalData.push({
              ...tempData,
            });
          }
          if (tempData?.is_tree) {
            tempData?.tree_data?.map((tree: any) => {
              if (tree?.to_show) {
                finalData.push({
                  ...tree,
                });
              }
              if (tree?.is_tree) {
                tree?.tree_data?.map((treeD: any) => {
                  if (treeD?.to_show) {
                    finalData.push({
                      ...treeD,
                    });
                  }
                  if (treeD?.is_tree) {
                    treeD?.tree_data?.map((treeD1: any) => {
                      if (treeD1?.to_show) {
                        finalData.push({
                          ...treeD1,
                        });
                      }
                    });
                  }
                });
              }
            });
          }
        });

      return {
        ...state,
        fetching: false,
        allLedgersList: result,
        allShowLedgersList: finalData,
        statusCode: status_code,
        allLedgersListTotal: total_count,
      };
    },
    [getAllLedgersListAction.rejected.toString()]: (
      state: ClientSettingsType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),
    [getAllExpensesLedgersListAction.pending.toString()]: (
      state: ClientSettingsType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getAllExpensesLedgersListAction.fulfilled.toString()]: (
      state: ClientSettingsType,
      { payload }
    ) => {
      const { status_code, result, message, success } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          error: message,
          statusCode: status_code,
        };
      }

      return {
        ...state,
        fetching: false,
        allExpensesLedgersList: result,
        statusCode: status_code,
      };
    },
    [getAllExpensesLedgersListAction.rejected.toString()]: (
      state: ClientSettingsType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),
    [getAllIncomeLedgersListAction.pending.toString()]: (
      state: ClientSettingsType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getAllIncomeLedgersListAction.fulfilled.toString()]: (
      state: ClientSettingsType,
      { payload }
    ) => {
      const { status_code, result, message, success } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          error: message,
          statusCode: status_code,
        };
      }

      return {
        ...state,
        fetching: false,
        allIncomeLedgersList: result,
        statusCode: status_code,
      };
    },
    [getAllIncomeLedgersListAction.rejected.toString()]: (
      state: ClientSettingsType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),
    [updateLedgerAction.pending.toString()]: (state: ClientSettingsType) => ({
      ...state,
      fetching: true,
    }),
    [updateLedgerAction.fulfilled.toString()]: (
      state: ClientSettingsType,
      { payload }
    ) => {
      const { success, status_code, message } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        success,
        statusCode: status_code,
        message,
      };
    },
    [updateLedgerAction.rejected.toString()]: (
      state: ClientSettingsType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),
    [getAllTypesLedgerListAction.pending.toString()]: (
      state: ClientSettingsType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getAllTypesLedgerListAction.fulfilled.toString()]: (
      state: ClientSettingsType,
      { payload }
    ) => {
      const { status_code, message, result, success } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          error: message,
          statusCode: status_code,
        };
      }

      let finalData =
        result &&
        result?.length > 0 &&
        result?.filter((data: any) => data?.to_show);

      return {
        ...state,
        fetching: false,
        allTypesLedgersList: finalData,
        statusCode: status_code,
      };
    },
    [getAllTypesLedgerListAction.rejected.toString()]: (
      state: ClientSettingsType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error?.message,
      success: 0,
    }),
    [getAllTypesWithTaxListAction.pending.toString()]: (
      state: ClientSettingsType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getAllTypesWithTaxListAction.fulfilled.toString()]: (
      state: ClientSettingsType,
      { payload }
    ) => {
      const { status_code, message, result, success } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          error: message,
          statusCode: status_code,
        };
      }
      let finalData =
        result &&
        result?.length > 0 &&
        result?.filter((data: any) => data?.to_show);
      return {
        ...state,
        fetching: false,
        allTypesLedgersWithTaxList: finalData,
        statusCode: status_code,
      };
    },
    [getAllTypesWithTaxListAction.rejected.toString()]: (
      state: ClientSettingsType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error?.message,
      success: 0,
    }),
    [checkUniqueLegalCustomerSupplierAction.pending.toString()]: (
      state: ClientSettingsType
    ) => ({
      ...state,
      uniqueLegalNameFetching: true,
    }),
    [checkUniqueLegalCustomerSupplierAction.fulfilled.toString()]: (
      state: ClientSettingsType,
      { payload }
    ) => {
      const { status_code, message, result, success } = payload;
      if (success === 0) {
        return {
          ...state,
          uniqueLegalNameFetching: false,
          success,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        uniqueLegalNameFetching: false,
        uniqueLegalNameMessage: message,
      };
    },
    [checkUniqueLedgerAction.rejected.toString()]: (
      state: ClientSettingsType,
      { error }
    ) => ({
      ...state,
      uniqueLegalNameFetching: false,
      success: 0,
      error: error?.message,
    }),
    [getSingleTypeLedgerListAction.pending.toString()]: (
      state: ClientSettingsType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getSingleTypeLedgerListAction.fulfilled.toString()]: (
      state: ClientSettingsType,
      { payload }
    ) => {
      const { status_code, result, message, success } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          error: message,
          statusCode: status_code,
        };
      }

      return {
        ...state,
        fetching: false,
        singleTypeLedgerList: result,
        statusCode: status_code,
      };
    },
    [getSingleTypeLedgerListAction.rejected.toString()]: (
      state: ClientSettingsType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),
    [getAllTypesStocksGroupAction.pending.toString()]: (
      state: ClientSettingsType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getAllTypesStocksGroupAction.fulfilled.toString()]: (
      state: ClientSettingsType,
      { payload }
    ) => {
      const { status_code, result, message, success, total_count } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          error: message,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        groupStockList: result,
        statusCode: status_code,
        groupStockListTotal: total_count,
      };
    },
    [getAllTypesStocksGroupAction.rejected.toString()]: (
      state: ClientSettingsType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),

    [addUnitMeasurementListAction.pending.toString()]: (
      state: ClientSettingsType
    ) => ({
      ...state,
      fetching: true,
    }),
    [addUnitMeasurementListAction.fulfilled.toString()]: (
      state: ClientSettingsType,
      { payload }
    ) => {
      const { success, message, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          error: message,
          statusCode: status_code,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
      };
    },
    [addUnitMeasurementListAction.rejected.toString()]: (
      state: ClientSettingsType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),

    [updateUnitsMeasermentAction.pending.toString()]: (
      state: ClientSettingsType
    ) => ({
      ...state,
      fetching: true,
    }),
    [updateUnitsMeasermentAction.fulfilled.toString()]: (
      state: ClientSettingsType,
      { payload }
    ) => {
      const { success, status_code, message } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        success,
        statusCode: status_code,
      };
    },
    [updateUnitsMeasermentAction.rejected.toString()]: (
      state: ClientSettingsType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),
    [addStockItemAction.pending.toString()]: (state: ClientSettingsType) => ({
      ...state,
      fetching: true,
    }),
    [addStockItemAction.fulfilled.toString()]: (
      state: ClientSettingsType,
      { payload }
    ) => {
      const { success, status_code, message } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        success,
        statusCode: status_code,
      };
    },
    [addStockItemAction.rejected.toString()]: (
      state: ClientSettingsType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),

    [updateStockItemAction.pending.toString()]: (
      state: ClientSettingsType
    ) => ({
      ...state,
      fetching: true,
    }),
    [updateStockItemAction.fulfilled.toString()]: (
      state: ClientSettingsType,
      { payload }
    ) => {
      const { success, status_code, message } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        success,
        statusCode: status_code,
      };
    },
    [updateStockItemAction.rejected.toString()]: (
      state: ClientSettingsType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),

    [getAllStockItemListAction.pending.toString()]: (
      state: ClientSettingsType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getAllStockItemListAction.fulfilled.toString()]: (
      state: ClientSettingsType,
      { payload }
    ) => {
      const { status_code, result, message, success } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          error: message,
          statusCode: status_code,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        allStockItemList: result.data,
        stockItemListTotal: result.total_count,
      };
    },
    [getAllStockItemListAction.rejected.toString()]: (
      state: ClientSettingsType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),

    [checkUniqueSkuNumberAction.pending.toString()]: (
      state: ClientSettingsType
    ) => ({
      ...state,
      uniqueSkuFetching: true,
      skuMessage: null,
    }),
    [checkUniqueSkuNumberAction.fulfilled.toString()]: (
      state: ClientSettingsType,
      { payload }
    ) => {
      const { success, message, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          success,
          fetching: false,
          uniqueSkuFetching: false,
          skuMessage: null,
          error: message,
          statusCode: status_code,
        };
      }

      return {
        ...state,
        fetching: false,
        uniqueSkuFetching: false,
        skuMessage: message,
      };
    },
    [checkUniqueSkuNumberAction.rejected.toString()]: (
      state: ClientSettingsType,
      { error }
    ) => ({
      ...state,
      uniqueSkuFetching: false,
      fetching: false,
      success: 0,
      error: error?.message,
    }),

    [getAllUnitMeasurementListAction.pending.toString()]: (
      state: ClientSettingsType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getAllUnitMeasurementListAction.fulfilled.toString()]: (
      state: ClientSettingsType,
      { payload }
    ) => {
      const { status_code, result, message, success } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          error: message,
          statusCode: status_code,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        allUnitsMeasurement: result.data,
        unitsMeasurementListTotal: result.total_count,
      };
    },
    [getAllUnitMeasurementListAction.rejected.toString()]: (
      state: ClientSettingsType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),

    [getAllTypesParentStockGroupAction.pending.toString()]: (
      state: ClientSettingsType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getAllTypesParentStockGroupAction.fulfilled.toString()]: (
      state: ClientSettingsType,
      { payload }
    ) => {
      const { status_code, result, message, success, total_count } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          error: message,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        groupParentStockList: result,
        statusCode: status_code,
        groupStockListTotal: total_count,
      };
    },
    [getAllTypesParentStockGroupAction.rejected.toString()]: (
      state: ClientSettingsType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),
    [addStockGrouopAction.pending.toString()]: (state: ClientSettingsType) => ({
      ...state,
      fetching: true,
    }),
    [addStockGrouopAction.fulfilled.toString()]: (
      state: ClientSettingsType,
      { payload }
    ) => {
      const { success, message, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          error: message,
          statusCode: status_code,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
      };
    },
    [addStockGrouopAction.rejected.toString()]: (
      state: ClientSettingsType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),
    [updateStockGroupAction.pending.toString()]: (
      state: ClientSettingsType
    ) => ({
      ...state,
      fetching: true,
    }),
    [updateStockGroupAction.fulfilled.toString()]: (
      state: ClientSettingsType,
      { payload }
    ) => {
      const { success, status_code, message } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        success,
        statusCode: status_code,
      };
    },
    [updateStockGroupAction.rejected.toString()]: (
      state: ClientSettingsType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),
    [getSingleStockItemDataAction.pending.toString()]: (
      state: ClientSettingsType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getSingleStockItemDataAction.fulfilled.toString()]: (
      state: ClientSettingsType,
      { payload }
    ) => {
      const { status_code, result, message, success } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          error: message,
          statusCode: status_code,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        singleStockItemData: result,
      };
    },
    [getSingleStockItemDataAction.rejected.toString()]: (
      state: ClientSettingsType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),
    //
    [getDepartmentListAction.pending.toString()]: (
      state: ClientSettingsType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getDepartmentListAction.fulfilled.toString()]: (
      state: ClientSettingsType,
      { payload }
    ) => {
      const { status_code, result, message, success } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          error: message,
          statusCode: status_code,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        departmentList: result.data,
        departmentTotalCount: result.total_count,
      };
    },
    [getDepartmentListAction.rejected.toString()]: (
      state: ClientSettingsType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),
    [getMultipleStockItemQuantityAction.pending.toString()]: (
      state: ClientSettingsType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getMultipleStockItemQuantityAction.fulfilled.toString()]: (
      state: ClientSettingsType,
      { payload }
    ) => {
      const { status_code, result, message, success } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          error: message,
          statusCode: status_code,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        multipleStockItemQuantityData: result,
      };
    },
    [getMultipleStockItemQuantityAction.rejected.toString()]: (
      state: ClientSettingsType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),

    [createDepartmentAction.pending.toString()]: (
      state: ClientSettingsType
    ) => ({
      ...state,
      fetching: true,
    }),
    [createDepartmentAction.fulfilled.toString()]: (
      state: ClientSettingsType,
      { payload }
    ) => {
      const { success, message, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          error: message,
          statusCode: status_code,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },
    [createDepartmentAction.rejected.toString()]: (
      state: ClientSettingsType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),

    [updateDepartmentAction.pending.toString()]: (
      state: ClientSettingsType
    ) => ({
      ...state,
      fetching: true,
    }),
    [updateDepartmentAction.fulfilled.toString()]: (
      state: ClientSettingsType,
      { payload }
    ) => {
      const { success, status_code, message } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        success,
        statusCode: status_code,
        message,
      };
    },
    [updateDepartmentAction.rejected.toString()]: (
      state: ClientSettingsType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),

    //
    [checkUniqueDepartmentNameAction.pending.toString()]: (
      state: ClientSettingsType
    ) => ({
      ...state,
      departmentUniqueCheckFetching: true,
    }),
    [checkUniqueDepartmentNameAction.fulfilled.toString()]: (
      state: ClientSettingsType,
      { payload }
    ) => {
      const { success, message, status_code } = payload?.data;

      if (success === 0) {
        return {
          ...state,
          success: success,
          departmentUniqueCheckFetching: false,
          error: message,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        departmentUniqueCheckFetching: false,
        departmentUniqueCheckMessage: message,
        statusCode: status_code,
        success: success,
      };
    },
    [checkUniqueDepartmentNameAction.rejected.toString()]: (
      state: ClientSettingsType,
      { error }
    ) => ({
      ...state,
      departmentUniqueCheckFetching: false,
      success: 0,
      error: error?.message,
    }),
    [getMappedPdfTemplateAction.pending.toString()]: (
      state: ClientSettingsType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getMappedPdfTemplateAction.fulfilled.toString()]: (
      state: ClientSettingsType,
      { payload }
    ) => {
      const { status_code, result, message, success } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success:0,
          error: message,
          statusCode: status_code,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        mappedPdfTemplate: result?.data,
      };
    },
    [getMappedPdfTemplateAction.rejected.toString()]: (
      state: ClientSettingsType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),

    [createMappedPdfTemplateAction.pending.toString()]: (
      state: ClientSettingsType
    ) => ({
      ...state,
      fetching: true,
    }),
    [createMappedPdfTemplateAction.fulfilled.toString()]: (
      state: ClientSettingsType,
      { payload }
    ) => {
      const { success, message, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          error: message,
          statusCode: status_code,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },
    [createMappedPdfTemplateAction.rejected.toString()]: (
      state: ClientSettingsType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),


    // 

    [multipleUploadFilesAction.pending.toString()]: (
      state: ClientSettingsType
    ) => ({
      ...state,
      multipleFileUploadFetching: true,
    }),
    [multipleUploadFilesAction.fulfilled.toString()]: (
      state: ClientSettingsType,
      { payload }
    ) => {
      const { success, message, status_code, stockFileUploadSuccess } = payload;

      if (success === 0) {
        return {
          ...state,
          multipleFileUploadFetching: false,
          multipleFileUploadError: message,
          statusCode: status_code,
          multipleFileUploadSuccess:success,
        };
      }

      return {
        ...state,
        multipleFileUploadFetching: false,
        statusCode: status_code,
        multipleFileUploadData: payload.files,
        multipleFileUploadSuccess:success,

      };
    },
    [multipleUploadFilesAction.rejected.toString()]: (
      state: ClientSettingsType,
      { error }
    ) => ({
      ...state,
      multipleFileUploadFetching: false,
      multipleFileUploadError: error?.message,
      multipleFileUploadSuccess: 0,

    }),
    
    // Bulk Upload in Stock Item

    [stockItemBulkUploadDataAction.pending.toString()]: (
      state: ClientSettingsType
    ) => ({
      ...state,
      fetching: true,
    }),
    [stockItemBulkUploadDataAction.fulfilled.toString()]: (
      state: ClientSettingsType,
      {payload}
    ) => {
      const { success, message, data = {}, status_code } = payload;

      if(success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          success,
          statusCode: status_code,
        };
      }
      return{
        ...state,
        fetching: false,
        statusCode: status_code,
        stockItemBulkUploadData: payload,
      };
    },
    [stockItemBulkUploadDataAction.rejected.toString()]: (
      state: ClientSettingsType,
      {error}
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),


  // Hsn check
    [addTurnOverHSNCheckAction.pending.toString()]: (
      state: ClientSettingsType
    ) => ({
      ...state,
      fetching: true,
    }),
    [addTurnOverHSNCheckAction.fulfilled.toString()]: (
      state: ClientSettingsType,
      { payload }
    ) => {
      const { success, message, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          error: message,
          statusCode: status_code,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },
    [addTurnOverHSNCheckAction.rejected.toString()]: (
      state: ClientSettingsType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),


    [updateTurnOverHSNCheckAction.pending.toString()]: (
      state: ClientSettingsType
    ) => ({
      ...state,
      fetching: true,
    }),
    [updateTurnOverHSNCheckAction.fulfilled.toString()]: (
      state: ClientSettingsType,
      { payload }
    ) => {
      const { success, message, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          error: message,
          statusCode: status_code,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },
    [updateTurnOverHSNCheckAction.rejected.toString()]: (
      state: ClientSettingsType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),
  
    [getHsnCheckAction.pending.toString()]: (
      state: ClientSettingsType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getHsnCheckAction.fulfilled.toString()]: (
      state: ClientSettingsType,
      { payload }
    ) => {
      const { status_code, result, message, success } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success:0,
          error: message,
          statusCode: status_code,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        clientMappedHSNData: result,
      };
    },
    [getHsnCheckAction.rejected.toString()]: (
      state: ClientSettingsType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),

    
    [addHsnCheckWarningAction.pending.toString()]: (
      state: ClientSettingsType
    ) => ({
      ...state,
      fetching: true,
    }),
    [addHsnCheckWarningAction.fulfilled.toString()]: (
      state: ClientSettingsType,
      { payload }
    ) => {
      const { success, message, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          warningSuccess:success,
          warningError: message,
          statusCode: status_code,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        warningSuccess:success,
        warningMessage:message,
      };
    },
    [addHsnCheckWarningAction.rejected.toString()]: (
      state: ClientSettingsType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      warningSuccess: 0,
      warningError: error?.message,
    }),

    [customerSupplierBulkUploadDataAction.pending.toString()]: (
      state: ClientSettingsType
    ) => ({
      ...state,
      fetching: true,
    }),
    [customerSupplierBulkUploadDataAction.fulfilled.toString()]: (
      state: ClientSettingsType,
      {payload}
    ) => {
      const { success, message, data = {}, status_code } = payload;
 
      if(success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          success,
          statusCode: status_code,
        };
      }
      return{
        ...state,
        fetching: false,
        statusCode: status_code,
        customerSupplierBulkUploadData: payload,
      };
    },
    [customerSupplierBulkUploadDataAction.rejected.toString()]: (
      state: ClientSettingsType,
      {error}
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),

    // batch management
    [addBatchManagementAction.pending.toString()]: (
      state: ClientSettingsType
    ) => ({
      ...state,
      fetching: true,
    }),
    [addBatchManagementAction.fulfilled.toString()]: (
      state: ClientSettingsType,
      { payload }
    ) => {
      const { success, message, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success:success,
          error: message,
          statusCode: status_code,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success:success,
        message:message,
      };
    },
    [addBatchManagementAction.rejected.toString()]: (
      state: ClientSettingsType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),

    [updateBatchManagementAction.pending.toString()]: (
      state: ClientSettingsType
    ) => ({
      ...state,
      fetching: true,
    }),
    [updateBatchManagementAction.fulfilled.toString()]: (
      state: ClientSettingsType,
      { payload }
    ) => {
      const { success, message, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          error: message,
          statusCode: status_code,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },
    [updateBatchManagementAction.rejected.toString()]: (
      state: ClientSettingsType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),

    [getBatchManagementAction.pending.toString()]: (
      state: ClientSettingsType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getBatchManagementAction.fulfilled.toString()]: (
      state: ClientSettingsType,
      { payload }
    ) => {
      const { status_code, result, message, success ,total_count} = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success:0,
          error: message,
          statusCode: status_code,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        batchManagementList: result,
        batchManagementListTotalCount:total_count
      };
    },
    [getBatchManagementAction.rejected.toString()]: (
      state: ClientSettingsType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),


[getSingleBatchManagementAction.pending.toString()]: (
  state: ClientSettingsType
) => ({
  ...state,
  fetching: true,
}),
[getSingleBatchManagementAction.fulfilled.toString()]: (
  state: ClientSettingsType,
  { payload }
) => {
  const { status_code, result, message, success } = payload;

  if (success === 0) {
    return {
      ...state,
      fetching: false,
      success:0,
      error: message,
      statusCode: status_code,
    };
  }

  return {
    ...state,
    fetching: false,
    statusCode: status_code,
    singlebatchDetailsData: result,
  };
},
[getSingleBatchManagementAction.rejected.toString()]: (
  state: ClientSettingsType,
  { error }
) => ({
  ...state,
  success: 0,
  error: error?.message,
  fetching: false,
}),

[changeBatchStatusAction.pending.toString()]: (
  state: ClientSettingsType
) => ({
  ...state,
  fetching: true,
}),
[changeBatchStatusAction.fulfilled.toString()]: (
  state: ClientSettingsType,
  { payload }
) => {
  const { success, status_code, message } = payload;

  if (success === 0) {
    return {
      ...state,
      error: message,
      success,
      statusCode: status_code,
    };
  }
  return {
    ...state,
    fetching: false,
    statusCode: status_code,
    success,
    message,
  };
},

[changeBatchStatusAction.rejected.toString()]: (
  state: ClientSettingsType,
  { error }
) => ({
  ...state,
  success: 0,
  error: error?.message,
  fetching: false,
}),

[checkUniqueBatchNumberAction.pending.toString()]: (
  state: ClientSettingsType
) => ({
  ...state,
  batchNumberFetching: true,
  batchNumberUniqueMessage: null,
}),
[checkUniqueBatchNumberAction.fulfilled.toString()]: (
  state: ClientSettingsType,
  { payload }
) => {
  const { success, message, status_code } = payload;

  if (success === 0) {
    return {
      ...state,
      success,
      batchNumberFetching: false,
      batchNumberUniqueMessage: null,
      error: message,
      statusCode: status_code,
    };
  }

  return {
    ...state,
    batchNumberFetching: false,
    batchNumberUniqueMessage: message,
  };
},
[checkUniqueBatchNumberAction.rejected.toString()]: (
  state: ClientSettingsType,
  { error }
) => ({
  ...state,
  batchNumberFetching: false,
  success: 0,
  error: error?.message,
}),
  //Add Auto Unique Number Generation
 
  [addAutoUniqueNumberGenerationAction.pending.toString()]: (
    state: ClientSettingsType
  ) => ({
    ...state,
    fetching: true,
  }),
  [addAutoUniqueNumberGenerationAction.fulfilled.toString()]: (
    state: ClientSettingsType,
    { payload }
  ) => {
    const { success, message, status_code } = payload;

    if(success === 0) {
      return {
        ...state,
        fetching: false,
        success,
        error: message,
        statusCode: status_code,
      };
    }

    return{
      ...state,
      fetching: false,
      statusCode: status_code,
      success,
      message,
    };
  },

  [addAutoUniqueNumberGenerationAction.rejected.toString()]: (
    state: ClientSettingsType,
    {error}
  ) => ({
    ...state,
    fetching: false,
    success: 0,
    error: error?.message,
  }),

  // Get Auto Unique Number Generation

  [getAutoUniqueNumberGenerationAction.pending.toString()]: (
    state: ClientSettingsType
  ) => ({
    ...state,
    fetching: true,
  }),
  [getAutoUniqueNumberGenerationAction.fulfilled.toString()]: (
    state: ClientSettingsType,
    {payload}
  ) => {
    const {status_code, result, message, success} = payload;

    if(success === 0) {
      return {
        ...state,
        fetching: false,
        success: 0,
        error: message,
        statusCode: status_code,
      };
    }

    return {
      ...state,
      fetching: false,
      statusCode: status_code,
      autoUniqueNumberGenerationData: result,
    };
  },

  [getAutoUniqueNumberGenerationAction.rejected.toString()]: (
    state: ClientSettingsType,
    { error }
  ) => ({
    ...state,
    success: 0,
    error: error?.message,
    fetching: false,
  }),
// stock mapped batch
[getStockMappedBatchListAction.pending.toString()]: (
  state: ClientSettingsType
) => ({
  ...state,
  fetching: true,
}),
[getStockMappedBatchListAction.fulfilled.toString()]: (
  state: ClientSettingsType,
  { payload }
) => {
  const { status_code, result, message, success ,total_count} = payload;

  if (success === 0) {
    return {
      ...state,
      fetching: false,
      success:0,
      error: message,
      statusCode: status_code,
    };
  }

  return {
    ...state,
    fetching: false,
    statusCode: status_code,
    mappedStockBatchList: result,
    mappedStockBatchListTotalCount:total_count
  };
},
[getStockMappedBatchListAction.rejected.toString()]: (
  state: ClientSettingsType,
  { error }
) => ({
  ...state,
  success: 0,
  error: error?.message,
  fetching: false,
}),

// customer supplier grouping

[getCustomerSupplierGroupingListAction.pending.toString()]: (
  state: ClientSettingsType
) => ({
  ...state,
  fetching: true,
}),
[getCustomerSupplierGroupingListAction.fulfilled.toString()]: (
  state: ClientSettingsType,
  { payload }
) => {
  const { success, message, result, status_code, total_count } = payload;

  if(success === 0) {
    return {
      ...state,
      fetching: false,
      success,
      error: message,
      statusCode: status_code,
    };
  }

  return {
    ...state,
    fetching: false,
    statusCode: status_code,
    customerSupplierGroupingList: result,
    customerSupplierGroupingTotalCount: total_count
  };
},
[getCustomerSupplierGroupingListAction.rejected.toString()]: (
  state: ClientSettingsType,
  { error }
) => ({
  ...state,
  fetching: false,
  success: 0,
  error: error?.message
})

  },
});

export const {
  resetClientSettingsError,
  resetClientSettingsFetching,
  resetClientSettingsStatusCode,
  resetClientSettingsSuccess,
  resetBusinessAddressList,
  resetCustomerSupplierList,
  resetLedgerMessage,
  resetAllLedgersList,
  resetAllExpensesLedgersList,
  resetAllIncomeLedgersList,
  resetSingleTypeLedgersList,
  resetLegalNameMessage,
  resetStockGroupList,
  resetAllUnitsMeasurmentList,
  resetStockItemList,
  resetSingleCustomerSupplier,
  resetCustomerSupplierMessage,
  resetStockGroupsListTotal,
  resetStockGroupActionList,
  resetCustomerSupplierListTotal,
  resetAllLedgersListTotal,
  resetStockItemListTotal,
  resetUnitsMeasurementListTotal,
  resetDepartmentTotalCount,
  resetDepartmentList,
  resetDepartmentMessage,
  resetDepartmentUniqueCheckFetching,
  resetDepartmentUniqueCheckMessage,
  resetSingleBusinessAddressList,
  resetSingleStockItemData,
  resetMultipleStockItemQuantityData,
  resetAllTypesLedgerListWithTaxList,
  resetMessage,
  resetMappedPdfTemplate,
  resetMultipleFileUploadFetching,
  resetMultipleFileUploadData,
  resetMultipleFileUploadError,
  resetMultipleFileUploadSuccess,
  resetStockItemBulkUpload,
  resetClientMappedHSNData,
  resetCustomerSupplierBulkUploadData,
  resetBatchManagementList,
  resetSinglebatchDetailsData,
  resetBatchNumberUniqueMessage,
  resetBatchManagementListTotalCount,
  resetAutoUniqueNumberGenerationData,
  resetMappedStockBatchList,
  resetMappedStockBatchListTotalCount,
  resetCustomerSupplierGroupingList,
  resetCustomerSupplierGroupingTotalCount
} = clientSettingsSlice.actions;
